<template>
  <common-dialog :value="getConfirmDialog.visible" width="400px" footer-style="padding-top: 0; border-top: 0 none;" @close="handleClose">
    <template #body>
      <div class="confirm-dialog-body">
        {{ getConfirmDialog.msg }}
      </div>
    </template>
    <template #footer>
      <a href="javascript:;" @click="handleCancel" class="btn cancel-btn">取消</a>
      <a href="javascript:;" @click="handleSubmit" class="btn confirm-btn">提交</a>
    </template>
  </common-dialog>
</template>
<script>
import CommonDialog from "@/components/CommonDialog";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "confirm-dialog",

  components: {
    CommonDialog
  },
  data() {
    return {};
  },

  computed: {
    ...mapGetters("order", ["getConfirmDialog"])
  },

  methods: {
    ...mapMutations("order", ["setConfirmDialog"]),
    async handleSubmit() {
      const result = await this.getConfirmDialog.requestFn();

      console.log('result', result)
      if (result) {
        this.handleClose()
      }
    },

    handleClose() {
      this.setConfirmDialog({
        visible: false
      });
    },

    handleCancel() {
      this.setConfirmDialog({
        visible: false
      });
    }
  }
};
</script>
<style lang="less" scoped>
.confirm-dialog-body {
  padding-top: 30px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmDialog/index.vue